export default {
  login: {
    name: 'login',
    hidden_menu: true,
  },
  cookies: {
    name: 'cookies',
    hidden_menu: true,
  },
  main: {
    name: 'main',
    hidden_menu: false,
  },
  settings: {
    name: 'settings',
    hidden_menu: false,
  },
  accounts: {
    name: 'accounts',
    hidden_menu: false,
  },
  booking: {
    name: 'booking',
    hidden_menu: false,
  },
  guest: {
    name: 'guest',
    hidden_menu: false,
  },
  checkin: {
    name: 'checkin',
    hidden_menu: false,
  },
  guestcheckin: {
    name: 'guestcheckin',
    hidden_menu: false,
  },
  guestcheckincompleted: {
    name: 'guestcheckincompleted',
    hidden_menu: false,
  },
  password: {
    name: 'password',
    hidden_menu: false,
  },
  activity_categories: {
    name: 'activity_categories',
    hidden_menu: false,
  },
  activities: {
    name: 'activities',
    hidden_menu: false,
  },
  activity_details: {
    name: 'activity_details',
    hidden_menu: false,
  },
  reservationComplete: {
    name: 'reservationComplete',
    hidden_menu: false,
  },
  reservationError: {
    name: 'reservationError',
    hidden_menu: false,
  },
  reservationSummary: {
    name: 'reservationSummary',
    hidden_menu: false,
  },
  reservationCommonData: {
    name: 'reservationCommonData',
    hidden_menu: false,
  },
  activity_reservations: {
    name: 'activity_reservations',
    hidden_menu: false,
  },
  loginCallback: {
    name: 'logging-in',
    hidden_menu: true,
  },
  reservationCatalog: {
    name: 'reservationCatalog',
    hidden_menu: false,
  },
  catalogProductSelection: {
    name: 'catalogProductSelection',
    hidden_menu: false,
  },
  catalogCategorySelection: {
    name: 'catalogCategorySelection',
    hidden_menu: false,
  },
  error: {
    name: 'error',
    hidden_menu: true,
  },
}
